import type { RuleSearch } from "~/lib/url/search";

export function normalizedProductQuery(value: string | undefined) {
  const query = value?.trim();
  return query && /^[\d.\s]+$/.test(query) ? query.replace(/\D/g, "") : query;
}
export function lookupContext(search: RuleSearch) {
  return {
    ncm: search.ncm,
    originUf: search.originUf,
    destinationUf: search.destinationUf,
    asOf: search.asOf,
    rulesetVersion: search.rulesetVersion,
  };
}
export function clearProductFilters(search: RuleSearch): RuleSearch {
  return { ...search, q: undefined, chapter: undefined, ncm: undefined, cursor: undefined };
}
export function swapRoute(search: RuleSearch): RuleSearch {
  return {
    ...search,
    originUf: search.destinationUf,
    destinationUf: search.originUf,
    cursor: undefined,
  };
}
